import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CountdownTimer from "../../Components/CountdownTimer";
import { toast } from "react-toastify";
import NodeaxiosInstance from "../../Services/nodeaxios";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"

const VerifyForgotOtp = () => {

    const [value, setValue] = useState('');
    //const [otp, setOTP] = useState("");
    const [otpError, setOTPError] = useState("");
    const [showResendOTP, setShowResendOTP] = useState(false);
    const [resendOTPType, setResendOTPType] = useState();

    const [triggerTimer, setTriggerTimer] = useState(false);

    const countDownTimerRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem("token");
    const vendorUrl = localStorage.getItem("vendorUrl");
    const [isLoading, setLoadingStatus] = useState(false);
    const [shoeRecentOTPOption, setShowResendOTPOption] = useState(false)
    const [otp, setOTP] = useState(['']);
    const [inputType, setInputType] = useState(location?.state?.inputType);


    useEffect(() => {

        let check = localStorage.getItem("login");
        // let productCart = localStorage.getItem("productCart");
        // && productCart.cartId
        // if (check == "logged") {
        //     navigate(-3);
        // }
        //  else {
        //     navigate('/')
        // } 
    }, [value]);

    const handleSubmit = (e) => {
        if (e) e.preventDefault();

        const enteredOtp = otp;

        if (enteredOtp.length != 4) {
            toast("Please enter a valid 4-digit OTP", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                className: 'text-danger toast-style-1'
            });
            return;
        }

        if (enteredOtp.length == 4) {
            setLoadingStatus(true);
            const body = {
                inputType: inputType,
                inputValue: location?.state?.inputValue,
                otp: enteredOtp.join(""),
            };

            NodeaxiosInstance.post('auth/forgot-password/verify', body)
                .then((res) => {
                    localStorage.setItem('token', res.data.jwt_token);

                    // if (res.data.reg_status == "2") {
                    //     navigate('/userRegister', { state: { mobileNumber: location.state.mobileNumber } });
                    // } else {
                    //     localStorage.setItem("login", "logged");
                    navigate('/change-password', {
                        state: { inputType: inputType, inputValue: location.state.inputValue }
                    });
                    // }
                })
                .catch((error) => {
                    toast("Please enter a valid 4-digit OTP", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                })
                .finally(() => {
                    setLoadingStatus(false);
                });
        }
    };
    const inputsRef = useRef([]);
    const numInputs = 4;


    const handleChange = (value, index) => {
        const digits = value.replace(/\D/g, "");
        if (!digits) return;

        const newOtp = [...otp];
        digits.split("").forEach((digit, i) => {
            if (index + i < numInputs) {
                newOtp[index + i] = digit;
            }
        });

        setOTP(newOtp);

        const nextIndex = Math.min(index + digits.length, numInputs - 1);
        inputsRef.current[nextIndex]?.focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];

            if (newOtp[index]) {
                newOtp[index] = "";
                setOTP(newOtp);
            } else if (index > 0) {
                inputsRef.current[index - 1]?.focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData("Text");
        if (!pastedData) return;
        const digits = pastedData.replace(/\D/g, "").slice(0, numInputs);
        if (digits.length == 0) return;
        const newOtp = Array(numInputs).fill("");
        digits.split("").forEach((digit, index) => {
            newOtp[index] = digit;
        });
        setOTP(newOtp);
        const focusIndex = digits.length >= numInputs ? numInputs - 1 : digits.length;
        inputsRef.current[focusIndex]?.focus();
    };


    const checkBtnDisable = () => {
        return otp?.length != 4 || otp.some((digit) => !digit || digit.trim() == "");
    };
    console.log('otp.length----', otp);

    return (
        <>
            <div className=" bg-white ">
                <div className="position-relative">
                    <img src={topBanaer} height="110px" width="100%" />
                    <img src={UserLogo} height="80px" width="80px" className="rounded-3 position-absolute top-100 start-50 translate-middle  mb-2 " />
                </div>
                <div className="loginPage p-0 vh-100 bg-white d-flex align-items-center">
                    <div className="px-4">
                        {
                            inputType == 1 ?
                                <>
                                    <div className="ff-poppins-bold fs-24 secondary-text">Verification Code</div>
                                    <div className="ff-poppins-regular ms-2 fs-14 secondary-text">We have sent the verification code to the {location.state.inputValue} email</div></> :
                                <>
                                    <div className="ff-balooPaaji-regular fs-24 secondary-text">Enter OTP</div>
                                    <div className="ff-poppins-regular ms-2 fs-14 secondary-text">We have sent you an SMS with 4 digit Verification code to the {location.state.inputValue} number </div>
                                </>
                        }

                        <form className='mt-4 text-center' onSubmit={handleSubmit}>
                            <div className="d-flex justify-content-center">
                                <div className="flex" onPaste={handlePaste}>
                                    {Array.from({ length: numInputs }).map((_, index) => (
                                        <input key={index} ref={(el) => (inputsRef.current[index] = el)} type="text"
                                            value={otp[index]} onChange={(e) => handleChange(e.target.value, index)} onKeyDown={(e) => handleKeyDown(e, index)}
                                            inputMode="numeric" autoComplete="one-time-code" className="otp-input bg-transparent me-3 text-center ff-balooPaaji2-regular fs-40 primary-text"
                                            style={{ width: "3rem", height: "3rem", margin: "0 0.5rem", textAlign: "center", background: "transparent", fontSize: "2rem", color: "var(--primary-text-color)" }}
                                        />
                                    ))}
                                </div>
                            </div>
                            <span className="ff-poppins-regular fs-14 text-danger">{otpError}</span>
                            <div className="d-flex justify-content-center">
                                <button type="submit" disabled={checkBtnDisable()}
                                    className={`${isLoading ? "loading" : ""}  ${checkBtnDisable() ? "opacity-40" : ""} primary-bg  w-100 border-0 rounded-pill 
                                     ff-poppins-semiBold fs-20 text-white mt-5 d-flex justify-content-center align-items-center`}>
                                    {isLoading ? <span className="loader-style-1"></span> : <span>Submit</span>}
                                </button>
                            </div>
                            <div className=" secondary-text-1  ">
                                <div className="text-center fs-12 ff-poppins-medium mt-2" onClick={() => navigate('/login', { state: { tabName: "Register", fromGuest: true } })}>
                                    Don't have an account?
                                    <span className="primary-text ms-1">Register.</span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
};

export default VerifyForgotOtp;